<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <label for="title" class="form-control-label">Titel</label>
        <input id="title" type="text" class="form-control" maxlength="255" placeholder="Geben Sie einen Titel ein" v-model="title">

        <label for="subtitle" class="form-control-label mt-2">Untertitel</label>
        <input id="subtitle" type="text" class="form-control" maxlength="255" placeholder="Geben Sie einen Untertitel ein" v-model="subtitle">
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-9">
        <ul class="nav nav-tabs justify-content-center nav-pills nav-fill">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'builder' }" @click="toggleActiveTab('builder')">
              <strong>Form Builder</strong>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'preview' }" @click="toggleActiveTab('preview')">
              <strong>Vorschau</strong>
            </a>
          </li>
        </ul>

        <div v-if="activeTab === 'builder'">
          <div class="selectedElementDiv">
            <h4 v-if="selectedElementList.length < 1">Klicken Sie auf ein Element in der Seitenleiste um es hinzuzufügen.</h4>
            <div v-for="el in sortedSelectedElements" v-else class="row">
              <div class="col-md-10 offset-md-1">
                <builder-text-element v-if="isElementOfType(el, 'text')" :element="el"></builder-text-element>
                <builder-title-element v-else-if="isElementOfType(el, 'title')" :element="el"></builder-title-element>
                <builder-text-input-element v-else-if="isElementOfType(el, 'inputText')" :element="el"></builder-text-input-element>
                <builder-signature-element v-else-if="isElementOfType(el, 'signature')" :element="el"></builder-signature-element>
                <builder-dropdown-element v-else-if="isElementOfType(el, 'dropdown')" :element="el"></builder-dropdown-element>
                <builder-single-select-element v-else-if="isElementOfType(el, 'singleSelect')" :element="el"></builder-single-select-element>
                <builder-multi-select-element v-else-if="isElementOfType(el, 'multiSelect')" :element="el"></builder-multi-select-element>
                <file-input-element v-else-if="isElementOfType(el, 'file')" :element="el"></file-input-element>
              </div>
            </div>
          </div>
          <button class="btn btn-outline-primary mt-3" @click="toggleActiveTab('preview')">
            <i class="fa fa-eye"></i> Vorschau ansehen
          </button>
        </div>


        <div v-if="activeTab === 'preview'">
          <div class="row">
            <div class="col-md-12">
              <form-preview :elements="sortedSelectedElements"></form-preview>
              <hr>
              <p>Wenn Sie mit dem Formular zufrieden sind, klicken Sie auf den nachfolgenden Button um das Formular zu
                {{ mode === "create" ? 'erstellen' : 'speichern' }}.</p>
              <button class="btn btn-outline-primary mt-1" @click="postForm">
                <i class="fa fa-save"></i> Formular {{ mode === "create" ? 'erstellen' : 'speichern' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3 text-center">
        <strong>Klicken Sie auf ein Element um es hinzuzufügen.</strong>
        <div class="list-group">
          <div :key="element.key" class="list-group-item list-group-item-action" v-for="element in elementList" @click="addToSelectedElements(element)">
            {{ element.name }}
          </div>
        </div>

        <div class="div" v-if="debug">
          <div class="row text-left">
            <div class="col-md-12">
              <div class="jsonContainer mt-3">
                <vue-json-pretty :data="jsonData"></vue-json-pretty>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import VueJsonPretty from 'vue-json-pretty'
import BuilderTextElement from './FormBuilder/elements/textelement';
import BuilderTitleElement from './FormBuilder/elements/titleelement';
import BuilderTextInputElement from './FormBuilder/elements/textinputelement';
import BuilderSignatureElement from './FormBuilder/elements/signatureelement';
import BuilderDropdownElement from './FormBuilder/elements/dropdownelement';
import BuilderSingleSelectElement from './FormBuilder/elements/singleselectelement';
import BuilderMultiSelectElement from './FormBuilder/elements/multiselectelement';
import fileInputElement from "./FormBuilder/elements/fileInputElement";

import FormPreview from './FormBuilder/elements/preview/FormPreview';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading);

export default {
  name: "FormBuilderComponent",
  components: {
    draggable,
    BuilderTextElement, BuilderTitleElement,
    BuilderTextInputElement, BuilderSignatureElement,
    BuilderDropdownElement, BuilderSingleSelectElement,
    BuilderMultiSelectElement, FormPreview, VueJsonPretty,
    Loading, fileInputElement
  },
  props: ['mode', 'formId'],
  data() {
    return {
      activeTab: 'builder',
      debug: false,
      title: '',
      subtitle: '',
      elementList: [
        {
          name: 'Titel',
          element: 'title',
          text: '',
        },
        {
          name: 'Text',
          element: 'text',
          text: '',
        },
        {
          name: 'Texteingabefeld',
          element: 'inputText',
          text: '',
          placeholder: '',
          validation: {
            required: false
          }
        },
        {
          name: 'Unterschriftenfeld',
          element: 'signature',
          text: '',
          validation: {
            required: true
          },
        },
        {
          name: 'Dropdown-Liste',
          element: 'dropdown',
          text: '',
          placeholder: '',
          values: [],
          validation: {
            required: false
          }
        },
        {
          name: 'Einzelauswahl-Liste',
          element: 'singleSelect',
          text: '',
          placeholder: '',
          values: [],
          validation: {
            required: false
          }
        },
        {
          name: 'Mehrfachauswahl-Liste',
          element: 'multiSelect',
          text: '',
          placeholder: '',
          values: [],
          validation: {
            required: false
          }
        },
        {
          name: 'Dokument',
          element: 'file',
          text: '',
          placeholder: '',
          validation: {
            required: false
          }
        },
      ],
      selectedElementList: [],
    }
  },
  computed: {
    jsonData() {
      if (this.selectedElementList.length > 0) {
        const vm = this;
        return this.sortedSelectedElements.map(function (el) {
          return JSON.parse(JSON.stringify(el));
        });
      }
      return {};
    },
    sortedSelectedElements() {
      return _.orderBy(this.selectedElementList, 'sort');
    }
  },
  mounted() {
    if (this.mode === "edit")
      this.loadFormData();
  },
  methods: {
    loadFormData() {
      let url = process.env.DASHBOARD_URL + '/api/v1/forms/:formId/formbuilder/get-json';
      url = url.replace(':formId', this.formId);

      let loader = this.$loading.show();
      let vm = this;

      axios.get(url)
          .then(function (response) {
            if (response.data) {
              vm.title = response.data.title;
              vm.subtitle = response.data.subtitle;

              if (response.data.raw_json === null) {
                vm.selectedElementList = [];
              } else {
                vm.selectedElementList = JSON.parse(response.data.raw_json);
              }
            }
            console.log(response);
            loader.hide();
          }).catch(function (error) {
        if (error.response !== undefined) {
          if (error.response.status === 400) {
            alert(error.response.data.error);
          }
        }
        console.log(error);
        loader.hide();
      });
    },
    areTitlesEmpty() {
      return this.title === '' || this.subtitle === '';
    },
    toggleActiveTab(string) {
      if (string !== 'builder' && string !== 'preview')
        return false;
      this.activeTab = string;
    },
    countSelectedElements() {
      return this.selectedElementList.length;
    },
    postForm() {
      if (this.areTitlesEmpty()) {
        alert("Titel und Untertitel müssen ausgefüllt werden.");
        return false;
      }
      if (this.countSelectedElements < 1) {
        alert("Das Formular muss mindestens ein Element enthalten.");
        return false;
      }

      let url = "";
      if (this.mode === 'edit') {
        url = process.env.DASHBOARD_URL + '/api/v1/forms/update/:formId';
        url = url.replace(':formId', this.formId);
      } else if (this.mode === "create") {
        url = process.env.DASHBOARD_URL + '/api/v1/forms/create';
      }

      axios.post(url, {
        title: this.title,
        subtitle: this.subtitle,
        jsonValue: JSON.stringify(this.jsonData)
      })
          .then(function (response) {
            if (response.data.url) {
              window.location.href = response.data.url;
            }
            console.log(response);
          }).catch(function (error) {
        if (error.response.status === 400) {
          alert(error.response.data.error);
        }
        console.log(error);
      });
    },
    calcElementKey() {
      let key = Math.max.apply(Math, this.selectedElementList.map(function (el) {
        return Math.max(el['key']);
      }));
      return key === -Infinity ? 1 : (key + 1);
    },
    calcElementSort() {
      let sort = Math.max.apply(Math, this.selectedElementList.map(function (el) {
        return Math.max(el['sort']);
      }));
      return sort === -Infinity ? 0 : (sort + 1);
    },
    moveElementUp(el) {
      if (this.hasLowestSort(el))
        return false;

      let shouldBeSort = el.sort - 1;

      let higherElement = this.findElementBySort(shouldBeSort);
      higherElement.sort = el.sort;
      el.sort = shouldBeSort;
    },
    moveElementDown(el) {
      if (this.hasHighestSort(el))
        return false;

      let shouldBeSort = el.sort + 1;

      let lowerElement = this.findElementBySort(shouldBeSort);
      lowerElement.sort = el.sort;
      el.sort = shouldBeSort;
    },
    hasLowestSort(el) {
      return el.sort === 0;
    },
    hasHighestSort(el) {
      return el.sort === Math.max.apply(Math, this.selectedElementList.map(function (element) {
        return element.sort;
      }));
    },
    isElementOfType(el, type) {
      return type === el.element;
    },
    addToSelectedElements(el) {
      let elCopy = JSON.parse(JSON.stringify(el));
      elCopy.sort = this.calcElementSort();
      elCopy.key = this.calcElementKey();
      this.selectedElementList.push(elCopy);
    },
    findElementBySort(sort) {
      return this.selectedElementList.find(function (element) {
        return sort === element.sort;
      });
    },
    removeElementByKey(key) {
      this.selectedElementList = this.selectedElementList.filter(function (element) {
        return key !== element.key;
      });
    }
  }
}
</script>

<style scoped>
.list-group-item {
  cursor: pointer;
}

.list-group-item:hover {
  background-color: #6a288a;
  font-weight: 800;
  color: white;
}

.selectedElementDiv {
  min-height: 80px;
  padding-top: 10px;
  background-color: lightgray;
  border: 2px dotted black;
}

.selectedElementDiv h4 {
  line-height: 80px;
  color: white;
  text-align: center;
}

.jsonContainer {
  background-color: whitesmoke;
  border: 1px solid black;
}
</style>
